import { axiosInterceptor } from "app/services/http-services/request-interceptor";

export type WorkScope = "mine" | "mine_and_groups";
export type WorkKind = "task" | "approval";
export type WorkItem = {
    source: "fluss_task" | "record";
    id: string;
    kind: WorkKind;
    title: string;
    number_ref: string | null;
    table: string | null;
    record_id: string | null;
    assignment: "me" | "group";
    group_label: string | null;
    requester: { id: string; name: string } | null;
    due_at: string | null;
    overdue: boolean;
    created_at: string;
    claimable: boolean;
    url: string;
};
export type WorkCounts = { tasks: number; approvals: number; total: number; scope: WorkScope };
export type WorkList = { items: WorkItem[]; counts: WorkCounts; scope: WorkScope };
type Envelope<T> = { success: boolean; data: T; error?: { code: string; message: string } };
export const myWorkKeys = {
    all: ["my-work"] as const,
    count: (scope: WorkScope) => ["my-work", "count", scope] as const,
    items: (scope: WorkScope, kind: WorkKind, limit: number, offset: number, search: string) =>
        ["my-work", "items", scope, kind, limit, offset, search] as const,
};
export const myWorkApi = {
    async getCount(scope?: WorkScope) {
        const response = await axiosInterceptor.get<Envelope<WorkCounts>>("/api/my_work/count", { params: { scope } });
        return response.data.data;
    },
    async listItems(params: { scope?: WorkScope; kind: WorkKind; limit?: number; offset?: number; search?: string }) {
        const response = await axiosInterceptor.get<Envelope<WorkList>>("/api/my_work/items", { params });
        return response.data.data;
    },
    async setPreference(scope: WorkScope) {
        const response = await axiosInterceptor.patch<Envelope<{ scope: WorkScope }>>("/api/my_work/preferences", { scope });
        return response.data.data;
    },
    async claim(source: WorkItem["source"], id: string) {
        const response = await axiosInterceptor.post<Envelope<{ item: WorkItem; counts: WorkCounts }>>("/api/my_work/claim", { source, id });
        return response.data.data;
    },
};
